module.exports = __webpack_public_path__ + "img/gal_23.b52c157e.png";